import {h, Fragment} from "preact"
import { useState } from "preact/hooks";
import { gridLayoutOptions } from "../config"

export default function GridLayoutToggles() {
    const [ gridLayout, setGridLayout ] = useState(window.innerWidth < 1200 ? 3 : 4);

    const handleGridChange = (value) => {
        const productGrid = document.getElementById('ns-product-grid');
        if(!productGrid || isNaN(value) || gridLayout === value) return;

        setGridLayout(value);
        productGrid.style.setProperty('--products-per-row', value);
        productGrid.querySelectorAll('.ns-image-carousel').forEach(el => el._splide?.refresh())
    }

    return (
        <div
            class="ns-grid-toggles ns-flex ns-flex-nowrap ns-items-center"
            aria-hidden="true"
        >
            {gridLayoutOptions.mobile && gridLayoutOptions.mobile.map(gridOption => (
                <button
                    class={`ns-grid-toggle ns-mobile-grid-toggle ns-flex ns-lg-hidden ns-flex-nowrap ns-items-center ${gridLayout === gridOption ? 'ns-selected' : ''}`}
                    type="button"
                    onClick={() => handleGridChange(gridOption)}
                    tabIndex="-1"
                >
                    {Array.from({ length: gridOption }).map((_, i) => (
                        <span key={i} class="ns-grid-icon ns-block" />
                    ))}
                </button>
            ))}
            {gridLayoutOptions.desktop && gridLayoutOptions.desktop.map(gridOption => (
                <button
                    class={`ns-grid-toggle ns-desktop-grid-toggle ns-hidden ns-lg-flex ns-flex-nowrap ns-items-center ${gridLayout === gridOption ? 'ns-selected' : ''}`}
                    type="button"
                    onClick={() => handleGridChange(gridOption)}
                    tabIndex="-1"
                >
                    {Array.from({ length: gridOption }).map((_, i) => (
                        <span key={i} class="ns-grid-icon ns-block" />
                    ))}
                </button>
            ))}
        </div>
    )
}
